import React, { useEffect, useState } from 'react';
import { Grid, Image, Modal, Button as SemanticButton } from 'semantic-ui-react';
import { Input, QRCode, Space, Button, Select } from 'antd';
import { CheckOutlined, CloseCircleOutlined } from '@ant-design/icons';
import GeneralHelper from '../../helpers/general';
import LabelHelper from '../../helpers/Label';
import UrlParse from 'url-parse';
import moment from 'moment';
import BackButton from '../../components/BackButton';
import Loading from '../../components/Loading';

const TicketDetailPage = (props) => {
	const {
		location,
		getTicketById,
		getLaundryRooms,
		updateTicketLaundryRoomById,
		resetPage,
		resetMeta,
		ticketDetailPageProps
	} = props;

	const [modalProceedVisible, setModalProceedVisible] = useState(false);
	const [selectedLaundryRoom, setSelectedLaundryRoom] = useState(null);

	const { ticket, laundry_rooms, meta } = ticketDetailPageProps;
	const { query } = UrlParse(location.search, true);

	const intervalIdRef = React.useRef();

	useEffect(() => {
		query.id && getTicketById(query.id);

		return () => resetPage();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (meta?.code === 200) {
			query.id && getTicketById(query.id);

			if (modalProceedVisible) {
				setModalProceedVisible(false);
			}

			resetMeta();
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	useEffect(() => {
		if (ticket) {
			const { _id: id, usage_status, selected_machine_id, laundry_room_id } = ticket;

			setSelectedLaundryRoom(laundry_room_id);

			if (selected_machine_id && usage_status === 'available') {
				intervalIdRef.current = setInterval(() => {
					getTicketById(id);
				}, 3000);
			} else {
				if (intervalIdRef.current) {
					// Clear Interval
					clearInterval(intervalIdRef.current);
				}

				// TODO: get Laundry Rooms for student
				getLaundryRooms();
			}
		}

		// Clear Interval
		return () => clearInterval(intervalIdRef.current);
	}, [getLaundryRooms, getTicketById, ticket]);

	const modalProceed = () => {
		const laundry_room = laundry_rooms.filter(room => room._id === selectedLaundryRoom)[0];
		return (
			<Modal
				style={{width: 400}}
				open={modalProceedVisible}
				onClose={() => setModalProceedVisible(false)}
			>
				<Modal.Header style={{borderBottom: '1px solid #DFDFDF', fontWeight: 'normal', fontSize: '15px', color: '#003366' }}>Laundry Room Change</Modal.Header>
				<Modal.Content style={{ padding: '14.5px', background: '#fff' }}>
					<Grid style={{ background: '#fff' }}>
						<Grid.Row style={{ background: '#fff' }}>
							<Grid.Column style={{ padding: '10px 20px', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
								<div style={{ textAlign: 'center' }}>You are changing your laundry room to "{laundry_room?.name}". Press "Proceed" to continue.</div>
								<div style={{ marginTop: 20 }}>Are you sure you want to proceed?</div>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Modal.Content>
				<Modal.Actions style={{ padding: 0, borderTop: '1px solid #DFDFDF', display: 'flex', flex: 1, flexDirection: 'row'}}>
					<SemanticButton
						style={{ width: '50%', margin: 0, padding: 20, background: '#fff', fontWeight: 'normal', borderRight: '0.5px solid #DFDFDF', borderRadius: 0 }}
						content="Cancel"
						onClick={() => setModalProceedVisible(false)}
					/>
					<SemanticButton
						style={{ width: '50%', margin: 0, padding: 20, background: '#fff', color: '#0088FF', fontWeight: 'normal', borderLeft: '0.5px solid #DFDFDF', borderRadius: 0 }}
						content="Proceed"
						onClick={() => updateTicketLaundryRoomById({ laundry_room_id: selectedLaundryRoom })}
					/>
				</Modal.Actions>
			</Modal>
		);
	};

	return (
		<div className="page-wrapper">
			<Grid container>
				<BackButton
					returnLocation="tickets"
					returnName="My Tickets"
					{...props}
				/>
				{ticket?.selected_machine_id && ticket?.usage_status !== 'used' &&
					<Grid.Row
						style={{
							height: 90,
							background: '#fff',
							borderRadius: 5,
							boxShadow: '0 2px 5px 0 rgba(0,0,0,0.2), 0 1px 2px 0 rgba(0,0,0,0.19)',
							display: 'flex',
							flexDirection: 'column',
							marginBottom: 15,
							padding: '10px 25px',
							justifyContent: 'space-between'
						}}
					>
						<div style={{display: 'flex', flexDirection: 'row'}}>
							<div style={{width: 130, color: '#003366', fontWeight: 'bold'}}>Activated Machine:</div>
							<div style={{color: '#003366'}}>{ticket?.selected_machine?.name}</div>
						</div>
						<div style={{display: 'flex', flexDirection: 'row'}}>
							<div style={{width: 130, color: '#003366', fontWeight: 'bold'}}>Service Type:</div>
							<div style={{color: '#003366'}}>{ticket?.service_type?.label}</div>
						</div>
						<div style={{display: 'flex', flexDirection: 'row'}}>
							<div style={{width: 130, color: '#003366', fontWeight: 'bold'}}>Laundry Room:</div>
							<div style={{color: '#003366'}}>{ticket?.laundry_room?.name}</div>
						</div>
					</Grid.Row>
				}
				<Grid.Row
					style={{
						...ticket?.selected_machine_id ? { height: 640 } : { height: 715},
						background: '#fff',
						borderRadius: 5,
						boxShadow: '0 2px 5px 0 rgba(0,0,0,0.2), 0 1px 2px 0 rgba(0,0,0,0.19)',
						display: 'flex',
						flexDirection: 'column'
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'center',
							marginTop: 30
						}}
					>
						<div
							style={{
								position: 'absolute',
								zIndex: 2,
								top: 23,
								border: '1px solid',
								...ticket?.service_type?.machine_type === 'washer' ? { backgroundColor: '#63CAE1' } : { backgroundColor: '#A1CD6E' },
								color: '#fff',
								padding: '10px',
								borderRadius: 25
							}}
						>
							{ticket?.service_type?.machine_type === 'washer' ? 'Washing Machine QR Code' : 'Dry Machine QR Code'}
						</div>
						<div>
							<div
								style={{
									position: 'relative',
									zIndex: 1,
									minHeight: 330,
									minWidth: 368,
									border: '1px solid #003366',
									borderRadius: '25px 25px 0px 0px',
									borderBottomStyle: 'dashed',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center'
								}}
							>
								<div
									style={{
										width: 0,
										height: 0,
										borderTop: '20px solid black',
										borderLeft: '15px solid #fff',
										borderBottom: '20px solid black',
										position: 'absolute',
										top: 308.5,
										left: -1
									}}
								/>
								<div
									style={{
										width: 0,
										height: 0,
										borderTop: '20px solid transparent',
										borderRight: '15px solid #fff',
										borderBottom: '20px solid transparent',
										position: 'absolute',
										top: 288,
										left: 0
									}}
								/>
								<div
									style={{
										width: 0,
										height: 0,
										borderTop: '20px solid transparent',
										borderRight: '15px solid #fff',
										borderBottom: '20px solid transparent',
										position: 'absolute',
										top: 328,
										left: 0
									}}
								/>
								<div style={{position: 'relative'}}>
									{ ticket?.token === undefined && ticket?.usage_status === undefined ?
										<Loading/>
										:
										ticket?.usage_status === 'used' ?
											<>
												<QRCode
													value={ticket?.token}
													size={250}
													style={{ background: '#fff', borderStyle: 'none' }}
													{...ticket?.usage_status === 'used' && {color: "#0C1F4080"}}
												/>
												<div
													style={{
														position: 'absolute',
														top: '50%',
														left: '50%',
														transform: 'translate(-50%, -50%)',
														textAlign: 'center'
													}}
												>
													<Image
														src={`${GeneralHelper.getImageBasePath()}/images/qr-used.svg`}
														style={{ width: 100, height: 100}}
													/>
												</div>
											</> : ticket?.usage_status === 'available' && moment(ticket?.expire_at).isBefore(moment()) ?
													ticket?.selected_machine_id ?
														<>
															<QRCode
																value={ticket?.token}
																size={250}
																style={{ background: '#fff', borderStyle: 'none' }}
																{...ticket?.usage_status === 'available' && {color: "#0C1F4080"}}
															/>
															<div
																style={{
																	position: 'absolute',
																	top: '50%',
																	left: '50%',
																	transform: 'translate(-50%, -50%)',
																	textAlign: 'center'
																}}
															>
																<Image
																	src={`${GeneralHelper.getImageBasePath()}/images/expired.svg`}
																	style={{ width: 100, height: 100}}
																/>
															</div>
														</> : <Image
															src={`${GeneralHelper.getImageBasePath()}/images/expired.svg`}
															style={{ width: 100, height: 100}}
														      />
												: !ticket?.selected_machine_id ?
													<span>Activate a Machine to generate QR Code.</span> :
													<QRCode
														value={ticket?.token}
														size={250}
														style={{ background: '#fff', borderStyle: 'none' }}
														{...ticket?.usage_status === 'used' && {color: "#0C1F4080"}}
													/>
									}
								</div>
								<div
									style={{
										width: 0,
										height: 0,
										borderTop: '20px solid black',
										borderRight: '15px solid #fff',
										borderBottom: '20px solid black',
										position: 'absolute',
										top: 308.5,
										right: -1
									}}
								/>
								<div
									style={{
										width: 0,
										height: 0,
										borderTop: '20px solid transparent',
										borderLeft: '15px solid #fff',
										borderBottom: '20px solid transparent',
										position: 'absolute',
										top: 288,
										right: 0
									}}
								/>
								<div
									style={{
										width: 0,
										height: 0,
										borderTop: '20px solid transparent',
										borderLeft: '15px solid #fff',
										borderBottom: '20px solid transparent',
										position: 'absolute',
										top: 328,
										right: 0
									}}
								/>
							</div>
							<div
								style={{
									zIndex: 1,
									minHeight: 150,
									minWidth: 368,
									border: '1px solid #003366',
									borderRadius: '0px 0px 25px 25px',
									borderTopStyle: 'none',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-evenly',
									flexDirection: 'column'
								}}
							>
								<div
									style={{
										display: 'flex',
										width: '80%',
										flexDirection: 'row',
										flex: 1,
										marginTop: 20
									}}
								>
									<span style={{ width: '50%', color: '#003366', fontWeight: 510 }}>Ticket ID</span>
									<span style={{ width: '50%', color: '#003366' }}>{ticket?.display_id}</span>
								</div>
								<div
									style={{
										display: 'flex',
										width: '80%',
										flexDirection: 'row',
										flex: 1
									}}
								>
									<span style={{ width: '50%', color: '#003366', fontWeight: 510 }}>Expiry Date</span>
									<span style={{ width: '50%', color: '#003366' }}>{ticket?.expire_at && moment(ticket.expire_at).format('MMMM DD, YYYY')}</span>
								</div>
								<div
									style={{
										display: 'flex',
										width: '80%',
										flexDirection: 'row',
										flex: 1
									}}
								>
									<span style={{ width: '50%', color: '#003366', fontWeight: 510 }}>Service Type</span>
									<span style={{ width: '50%', color: '#003366'  }}>{ticket?.service_type?.label}</span>
								</div>
								<div
									style={{
										display: 'flex',
										width: '80%',
										flexDirection: 'row',
										flex: 1
									}}
								>
									<span style={{ width: '50%', color: '#003366', fontWeight: 510}}>Laundry Room</span>
									{
										!ticket?.selected_machine_id ? (
											<Select
												placeholder="Select Room"
												style={{ width: '50%' }}
												options={(() => {
													const availableLaundryRooms = [];
													const { machine_type, service_type_id } = ticket || {};

													for (let i = 0; i < laundry_rooms.length; i++) {
														const laundry_room = laundry_rooms[i];
														const { machines } = laundry_room;

														const availableMachines  = machines.filter(machine => machine.machine_type === machine_type && machine.service_type_id === service_type_id);

														if (availableMachines.length > 0) {
															availableLaundryRooms.push(laundry_room);
														}
													}

													return availableLaundryRooms;
												})().map(laundry_room => {
													return {
														value: laundry_room?._id,
														label: laundry_room?.name
													};
												})}
												onChange={val => {
													setSelectedLaundryRoom(val);
													setModalProceedVisible(true);
												}}
												value={selectedLaundryRoom === ticket?.laundry_room_id ? selectedLaundryRoom : ticket?.laundry_room_id}
												required
											/>
										) : (
											<span style={{ width: '50%', color: '#003366' }}>{ticket?.laundry_room?.name}</span>
										)
									}
								</div>
								<div
									style={{
										display: 'flex',
										width: '80%',
										flexDirection: 'row',
										flex: 1
									}}
								>
									<span style={{ width: '50%', color: '#003366', fontWeight: 510 }}>Invoice Number</span>
									<span style={{ width: '50%', color: '#003366' }}>{ticket?.invoice_number}</span>
								</div>
								<div
									style={{
										display: 'flex',
										width: '80%',
										flexDirection: 'row',
										flex: 1
									}}
								>
									<span style={{ width: '50%', color: '#003366', fontWeight: 510 }}>Price</span>
									<span style={{ width: '50%', color: '#003366' }}>{ticket?.price && `$${parseFloat(ticket?.price).toFixed(2)} HKD`}</span>
								</div>
								<div
									style={{
										display: 'flex',
										width: '80%',
										flexDirection: 'row',
										flex: 1
									}}
								>
									<span style={{ width: '50%', color: '#003366', fontWeight: 510 }}>Payment Method</span>
									<span style={{ width: '50%', color: '#003366' }}>{LabelHelper.paymentMethod(ticket?.payment_method)}</span>
								</div>
								<div
									style={{
										display: 'flex',
										width: '80%',
										flexDirection: 'row',
										flex: 1,
										marginBottom: 20
									}}
								>
									<span style={{ width: '50%', color: '#003366', fontWeight: 510 }}>Payment Status</span>
									<span style={{ width: '50%', color: '#003366' }}>{LabelHelper.paymentStatus(ticket?.payment_status)}</span>
								</div>
							</div>
						</div>
					</div>
					{ticket?.usage_status === 'available' && moment(ticket?.expire_at).isAfter(moment()) &&
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'center',
								marginTop: 20
							}}
						>
							<Button
								style={{ minWidth: 368, height: 40, border: '1px solid', borderColor: '#003366', borderRadius: '50px', background: '#fff',
									...ticket?.payment_status !== 'paid' ? { borderColor: '#ccc' } : { borderColor: '#003366' } }}
								onClick={() => props.history.push(`/tickets/id/reserve-machine?id=${ticket._id}`)}
								{...ticket?.payment_status !== 'paid' && { disabled: true }}
							>
								<CheckOutlined style={{ fontSize: 16, fontWeight: 'bold', ...ticket?.payment_status !== 'paid' ? { color: '#c1c1c1' } : { color: '#003366' } }} />
								<p style={{ display: 'inline-block', marginLeft: '5px', ...ticket?.payment_status !== 'paid' ? { color: '#c1c1c1' } : { color: '#003366' } }}>Activate a Machine</p>
							</Button>
						</div>
					}
				</Grid.Row>
			</Grid>
			{modalProceed()}
		</div>
	);
};

export default TicketDetailPage;
